import { useCallback, useEffect, useState } from "react";
import { getProducts } from "../services/wooCommerceApi";
import { WordPressApiError } from "../services/wordpressClient";
import { isWordPressConfigured } from "../constants/wordpress";

export function useProducts({ categoryId, page = 1, search } = {}) {
  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProducts = useCallback(async () => {
    if (!isWordPressConfigured()) {
      setError("WordPress API credentials are not configured.");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await getProducts({ page, categoryId, search });
      setProducts(result.products);
      setTotal(result.total);
      setTotalPages(result.totalPages);
    } catch (err) {
      const message =
        err instanceof WordPressApiError
          ? err.message
          : "Failed to load products.";
      setError(message);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  }, [categoryId, page, search]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  return { products, total, totalPages, loading, error, refetch: fetchProducts };
}
